import { FC } from 'react';
import { AddressType } from '../types';
import { getDisplayName } from '../utils';
import styles from './formats.module.scss';
interface DefaultFormatAddressProps {
  isFullAddress?: boolean;
  address: AddressType;
  isAddressTypeDisplay?: boolean;
  translatedAddressType?: string;
}

export const DefaultFormatAddress: FC<DefaultFormatAddressProps> = ({
  isFullAddress,
  address,
  isAddressTypeDisplay,
  translatedAddressType
}) => {
  const {
    address1,
    address2,
    firstName,
    middleName,
    lastName,
    city,
    country,
    email,
    phone,
    state,
    zipCode
  } = address;
  const statePrefix = city && state ? ', ' : '';
  const zipCodePrefix = (city || state) && zipCode ? ' ' : '';

  return (
    <div data-testid="address-default" className={styles['formats']}>
      {isAddressTypeDisplay && (
        <p className="cat-u-theme-typography-label mb-0" data-cs-mask>
          {translatedAddressType}
        </p>
      )}
      <p className="mb-0 exclude-global" data-cs-mask>
        {getDisplayName(firstName, middleName, lastName)}
      </p>
      {address1 && (
        <p className="mb-0 exclude-global" data-cs-mask>
          {address1}
        </p>
      )}
      {address2 && (
        <p className="mb-0 exclude-global" data-cs-mask>
          {address2}
        </p>
      )}
      {(city || state || zipCode) && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-mask>
          {city}
          {statePrefix}
          {state}
          {zipCodePrefix}
          {zipCode}
        </p>
      )}
      {country && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-mask>
          {country}
        </p>
      )}
      {phone && isFullAddress && (
        <p className="mb-0 exclude-global" data-cs-mask>
          {phone}
        </p>
      )}
      {email && isFullAddress && (
        <p className="mb-0 exclude-global" data-cs-mask>
          {email}
        </p>
      )}
    </div>
  );
};
